export default __webpack_public_path__ + "static/2-03e2464a82a52bebeb9e211e222ced00.jpeg";